import { toast } from "sonner";
import { useApi, useResource } from "@/lib/api";
import { PageHeader, Panel, StatusPill, Loading, ErrorNote } from "@/components/kit";

export default function Releases() {
  const { data, error, loading } = useResource("/releases");
  const call = useApi();
  const tryPublish = async (id) => {
    try { await call(`/releases/${id}/publish`, { method: "POST" }); } catch (e) { toast.error(e.message); }
  };
  if (loading) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  return (
    <div>
      <PageHeader eyebrow="Release · L3/L4 (not granted)" title="Release Management" />
      <div className="mb-6 rounded-sm border-l-4 border-[var(--cc-signal)] bg-white p-4 text-sm" data-testid="release-boundary-note">
        Phase 1 grants no Release (L3) or Production (L4) authority. The original Cruise Command application is out of scope: no access, no publishing, Publish 98 rollback preserved.
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {data.map((r) => (
          <Panel key={r.id} testId={`release-card-${r.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div><p className="font-mono text-xs text-[var(--cc-muted)]">{r.id}</p><h3 className="mt-1 text-xl font-extrabold text-[var(--cc-navy)]">{r.name}</h3></div>
              <StatusPill status={r.status} />
            </div>
            <p className="mt-3 text-sm text-[var(--cc-muted)]">Target: {r.target}</p>
            {r.note && <p className="mt-1 text-xs">{r.note}</p>}
            <p className="mt-3 text-xs">Production authority: <b className="text-[var(--cc-deny)]">{String(r.production_authority)}</b></p>
            <button data-testid={`release-publish-${r.id}`} onClick={() => tryPublish(r.id)} className="mt-4 rounded-sm border border-[var(--cc-line)] px-4 py-2 text-xs text-[var(--cc-muted)] transition-colors hover:border-[var(--cc-deny)] hover:text-[var(--cc-deny)]">Attempt publish (expected: denied)</button>
          </Panel>
        ))}
      </div>
    </div>
  );
}
